"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines-per-function */
/** @jsx jsx */
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const summithill_models_1 = require("@clearsummit/summithill-models");
const defaults_1 = require("@clearsummit/summithill-models/lib/defaults");
const core_1 = require("@emotion/core");
const framer_motion_1 = require("framer-motion");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_div_100vh_1 = __importDefault(require("react-div-100vh"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const process_question_item_1 = __importDefault(require("./process-question-item"));
const session_item_1 = __importDefault(require("./session-item"));
const step_banner_1 = __importDefault(require("./step-banner"));
const step_layout_1 = __importDefault(require("./step-layout"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const utils_1 = require("./utils");
const video_item_1 = __importDefault(require("./video-item"));
const renderItem = ({ item, section, setActiveStep, expandedSection, activeStep, isAvailable, videoProgress, setVideoProgress, closeStepLayout, sessionStepOne, }) => {
    if (section.id === expandedSection) {
        if (item instanceof summithill_models_1.Video) {
            const available = isAvailable(section.id, item.id);
            return (core_1.jsx(video_item_1.default, { key: `item-${item.id}`, index: item.id, video: item, onClick: () => {
                    closeStepLayout();
                    if (available || item.completed) {
                        setVideoProgress(0);
                        setActiveStep({ step: item, sectionId: section.id });
                    }
                }, progress: videoProgress, activeVideo: activeStep instanceof summithill_models_1.Video ? activeStep : null, available: available }));
        }
        if (item instanceof summithill_models_1.Session) {
            const activeSection = isAvailable(section.id, item.id);
            const sessionType = defaults_1.snakeToCamel(item.sessionType);
            const onClick = () => {
                closeStepLayout();
                if (activeSection || item.completed) {
                    setActiveStep({ step: item, sectionId: section.id });
                }
                if (activeSection && !item.completed) {
                    sessionStepOne({ type: sessionType });
                }
            };
            return (core_1.jsx(session_item_1.default, { key: `item-${item.id}`, index: item.id, sessionType: item.sessionType, completed: item.completed, active: activeSection, onClick: onClick }));
        }
    }
    return null;
};
const renderSections = (program, sections, expandedSection, setExpandedSection, isAvailable, setActiveStep, activeStep, videoProgress, setVideoProgress, closeStepLayout, sessionStepOne, processQuestions) => sections.map((section) => {
    var _a, _b;
    const { id, name, data, videosCompletedTotal, videosTotal, videosCompleted, processQuestionCompleted, sessionType, processQuestion, completed } = section;
    let sectionCompleted = videosCompleted;
    let subtitle = '';
    let isActive = false;
    if (section instanceof summithill_models_1.Section) {
        if (processQuestion) {
            subtitle = constants_1.default.program.sectionStatus(processQuestionCompleted ? videosCompletedTotal + 1 : videosCompletedTotal, videosTotal + 1);
        }
        else {
            subtitle = constants_1.default.program.sectionStatus(videosCompletedTotal, videosTotal);
        }
        const playing = !!((activeStep === null || activeStep === void 0 ? void 0 : activeStep.step) && data.map((v) => v.id).includes((_a = activeStep.step) === null || _a === void 0 ? void 0 : _a.id));
        isActive = ((sectionCompleted && videosTotal > 0) || (expandedSection === id) || playing);
    }
    else if (section instanceof summithill_models_1.SessionSection) {
        subtitle =
            constants_1.default.program.sessionType[defaults_1.snakeToCamel(sessionType)];
        sectionCompleted = completed;
        isActive = sectionCompleted || (expandedSection === id);
    }
    return (core_1.jsx(components_1.Accordion, { key: `section-${id}`, open: expandedSection === id, label: name, badgeLabel: subtitle, isActive: isActive, onClick: () => {
            setExpandedSection(expandedSection === id ? null : id);
        } },
        core_1.jsx("div", null,
            data.map((item) => renderItem({
                item,
                section,
                expandedSection,
                isAvailable,
                setActiveStep,
                activeStep: activeStep === null || activeStep === void 0 ? void 0 : activeStep.step,
                videoProgress,
                setVideoProgress,
                closeStepLayout,
                sessionStepOne,
            })),
            processQuestion && expandedSection === id ? (core_1.jsx(process_question_item_1.default, { index: processQuestion.id, unlocked: ((_b = utils_1.getNextIncompleteStep(utils_1.getCurrentIncompleteSection(sections), null)) === null || _b === void 0 ? void 0 : _b.id) === processQuestion.id, questions: processQuestion.questions, questionsId: processQuestion.id, activeQuestions: (activeStep === null || activeStep === void 0 ? void 0 : activeStep.step) instanceof summithill_models_1.ProcessQuestion ? activeStep.step : null, completed: processQuestion.completed, onClick: () => {
                    const currentSection = utils_1.getCurrentIncompleteSection(sections);
                    const nextIncompleteStep = utils_1.getNextIncompleteStep(currentSection, null);
                    if ((nextIncompleteStep === null || nextIncompleteStep === void 0 ? void 0 : nextIncompleteStep.id) === processQuestion.id || processQuestion.completed) {
                        closeStepLayout();
                        setActiveStep({ step: processQuestion, sectionId: id });
                        if (!processQuestion.completed) {
                            processQuestions({
                                questions: processQuestion.questions,
                                sectionId: id,
                                processQuestionId: processQuestion.id,
                                programId: program.id,
                            });
                        }
                    }
                } })) : null)));
});
const ProgramScreen = ({ user, program, sections, getSectionsPending, getSectionsNextPage, completeVideo, isAvailable, getSections, sessionStepOne, closeStepLayout, stepLayoutOpen, processQuestions, processQuestionsSummary, }) => {
    var _a;
    const [page, setPage] = react_1.useState(1);
    const [expandedSection, setExpandedSection] = react_1.useState(null);
    const [activeStep, setActiveStep] = react_1.useState(null);
    const [videoProgress, setVideoProgress] = react_1.useState(null);
    const selectNextStep = (currentStepId) => {
        const currentIncompleteSection = utils_1.getCurrentIncompleteSection(sections);
        if (currentIncompleteSection) {
            const nextIncompleteStep = utils_1.getNextIncompleteStep(currentIncompleteSection, currentStepId);
            if (nextIncompleteStep) {
                setExpandedSection(currentIncompleteSection.id);
                setActiveStep({ step: nextIncompleteStep, sectionId: currentIncompleteSection.id });
            }
        }
    };
    react_1.useLayoutEffect(() => {
        if (!getSectionsPending && !lodash_1.isEmpty(sections)) {
            selectNextStep(null);
        }
    }, [getSectionsPending]);
    if (lodash_1.isEmpty(program)) {
        return core_1.jsx(components_1.ScreenLoader, null);
    }
    const { paywallActive, showPaywall } = user;
    if (paywallActive && showPaywall) {
        return core_1.jsx(react_router_dom_1.Redirect, { to: constants_1.Routes.PaywallSessions });
    }
    return (core_1.jsx(react_div_100vh_1.default, { className: styles_scss_1.default.container },
        core_1.jsx(components_1.Meta, { title: constants_1.default.program.helmetTitle }),
        core_1.jsx("div", { className: styles_scss_1.default.sectionsContainer },
            core_1.jsx("div", { className: styles_scss_1.default.programTitle },
                core_1.jsx("h4", null, program.name)),
            core_1.jsx(components_1.Scrollable, { className: styles_scss_1.default.sectionsCont, onEndReached: () => {
                    if (getSectionsNextPage && !getSectionsPending) {
                        const nextPage = page + 1;
                        setPage(nextPage);
                        getSections({
                            id: program.id,
                            page: nextPage,
                        });
                    }
                } }, renderSections(program, sections, expandedSection, setExpandedSection, isAvailable, setActiveStep, activeStep, videoProgress, setVideoProgress, closeStepLayout, sessionStepOne, processQuestions))),
        core_1.jsx("div", { className: styles_scss_1.default.stepContainer, css: styles_1.default.stepContainer((activeStep === null || activeStep === void 0 ? void 0 : activeStep.step) instanceof summithill_models_1.Video &&
                !(paywallActive && utils_1.shouldShowPaywallBanner(activeStep === null || activeStep === void 0 ? void 0 : activeStep.sectionId, sections)), activeStep) },
            core_1.jsx(framer_motion_1.AnimatePresence, null, !stepLayoutOpen ? (core_1.jsx(step_banner_1.default, { user: user, sections: sections, activeStep: activeStep, completeVideo: data => {
                    completeVideo(Object.assign({ programId: program.id }, data));
                    selectNextStep(data.videoId);
                }, setVideoProgress: setVideoProgress, sessionStepOne: sessionStepOne, processQuestions: processQuestions, program: program, processQuestionsSummary: processQuestionsSummary, setActiveStep: setActiveStep, setExpandedSection: setExpandedSection })) : (core_1.jsx(step_layout_1.default, { selectNextStep: selectNextStep, currentStepId: (_a = activeStep === null || activeStep === void 0 ? void 0 : activeStep.step) === null || _a === void 0 ? void 0 : _a.id }))))));
};
const mapStateToProps = (state) => {
    const user = selectors_1.default.user.getUser(state);
    // We only get first program for this MVP version
    const programId = lodash_1.get(user, 'programs[0]', null);
    const program = selectors_1.default.program.getProgram(state, lodash_1.get(user, 'programs[0]', null));
    return {
        program,
        user,
        isAvailable: (sectionId, contentId) => selectors_1.default.program.isAvailable(state, programId, sectionId, contentId),
        sections: selectors_1.default.program.getSections(state, programId),
        getSectionsPending: selectors_1.default.api.getPending(state, services_1.endpoints.getSections),
        getSectionsNextPage: selectors_1.default.program.getSectionsNextPage(state, programId),
        stepLayoutOpen: selectors_1.default.stepLayout.getStepLayoutOpen(state)
    };
};
const mapDispatchToProps = (dispatch) => ({
    closeStepLayout: () => dispatch(redux_1.ActionCreators.stepLayout.closeStepLayout.dispatch()),
    sessionStepOne: (payload) => dispatch(redux_1.ActionCreators.stepLayout.sessionStepOne.dispatch(payload)),
    processQuestions: (payload) => dispatch(redux_1.ActionCreators.stepLayout.processQuestions.dispatch(payload)),
    processQuestionsSummary: (payload) => dispatch(redux_1.ActionCreators.stepLayout.processQuestionsSummary.dispatch(payload)),
    getSections: data => dispatch(radio_dispatch_1.reduxSet.makeLatestRequest.dispatch(api_payloads_1.getSectionsPayload(data))),
    completeVideo: ({ programId, sectionId, videoId }) => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.setVideoStatePayload({
        programId,
        sectionId,
        videoId,
        state: summithill_models_1.VideoState.COMPLETE,
    }))),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ProgramScreen);
